<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Picking
            <ModalRelatorioPicking
              @filtrar="buscarRelatorio"
              :loadingValue="loadingValue"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'pkg-relatorio-picking'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import ModalRelatorioPicking from "../components/ModalRelatorioPicking.vue";
import Flexmonster from "../components/Flexmonster.vue";

export default {
  components: { Flexmonster, ModalRelatorioPicking },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref([]);
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");

    const buscarRelatorio = async (params) => {
      try {
        let filtrosObject = {};
        if (params.unidadeOrigemId)
          filtrosObject.unidadeOrigem = params.unidadeOrigemId;
        if (params.unidadeDestinoId)
          filtrosObject.unidadeDestino = params.unidadeDestinoId;
        if (params.numeroRequisicao)
          filtrosObject.numeroRequisicao = params.numeroRequisicao;
        if (params.numeroPicking)
          filtrosObject.numeroPicking = params.numeroPicking;
        if (params.produto) filtrosObject.produto = params.produto;

        loadingValue.value = true;

        const response = await store.dispatch("pkg/getRelatorioPicking", {
          dataInicial: params.dataInicial,
          dataFinal: params.dataFinal,
          unidadeOrigemId: params.unidadeOrigemId,
          unidadeDestinoId: params.unidadeDestinoId,
          numeroRequisicao: params.numeroRequisicao,
          numeroPicking: params.numeroPicking,
          produto: params.produto,
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.return.url;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      buscarRelatorio,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>
